(function () {
  function init() {
    var dialog = document.querySelector('#filters-drawer dialog');
    if (!dialog || dialog._dfBridged) return;
    dialog._dfBridged = true;

    var sectionId = dialog.closest('.shopify-section').id.replace('shopify-section-', '');

    function getForm() {
      return document.getElementById('FacetFiltersFormComponent--' + sectionId + '-overflow');
    }

    dialog.addEventListener('click', function (e) {
      // CLEAR ALL
      if (e.target.closest('#df-clear-all-btn')) {
        var form = getForm();
        if (!form) return;
        form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.checked = false;
        });
        var radios = form.querySelectorAll('input[type="radio"][name="sort_by"]');
        if (radios.length) radios[0].checked = true;
        form.updateFilters();
        return;
      }

      // APPLY
      if (e.target.closest('.facets__see-results')) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var form = getForm();
        if (form && form.updateFilters) form.updateFilters();
        requestAnimationFrame(function () {
          var dc = dialog.closest('dialog-component');
          if (dc && dc.closeDialog) dc.closeDialog();
        });
      }
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();